export enum DemoType {
    TGXP,
    BrainCool
}